export const ERROR_CODE = {
    USER_EXISTED: '409001'
}


// WEBPACK FOOTER //
// ./src/constants/error-code.js